module.exports = __webpack_public_path__ + "media/images/client/zoom_icon-580f394394f4b63b986272d15b2ea376.png";